import React from 'react';

import type { BlockTeam } from 'types/block-team';

import Image from 'next/image';

import { Paragraph, Wrap } from '@leafwell/components';

import Figure from './figure';
import HeadingBody from './heading-body';

const Team: React.FC<BlockTeam> = ({ sectionId, title, items }) => {
  return (
    <Wrap id={sectionId} size="large" className="">
      <HeadingBody
        className="text-center font-semibold"
        level="2"
        title={title}
        tagName="h2"
      />
      {items.length > 0 ? (
        <ul className="team relative grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-10">
          {items?.map(
            ({ id, profilePageUrl, name, featuredImage, jobs }, idx) => {
              const jobTitle = React.useMemo(() => {
                if (jobs && jobs.length > 0) {
                  return jobs.map(({ name }) => name).join(' & ');
                }
                return null;
              }, [jobs]);

              const isLeafwellUrl = profilePageUrl
                ? new URL(profilePageUrl).host?.includes('leafwell')
                : false;

              //determine grid-area -- grid-area-template is defined in styles.css
              return (
                <li key={id} id={`member-${idx}`} className="grid">
                  <a
                    href={profilePageUrl}
                    target={isLeafwellUrl ? '_self' : '_blank'}
                  >
                    <Figure {...featuredImage} />
                    <Paragraph
                      className="font-medium mt-2"
                      dangerouslySetInnerHTML={{ __html: name }}
                    />
                    {jobTitle && (
                      <Paragraph size="xsmall" className="">
                        {jobTitle}
                      </Paragraph>
                    )}
                  </a>
                </li>
              );
            },
          )}
          <Image
            src="/about-team-1.svg"
            width={194}
            height={493}
            alt="Play video"
            className="hidden xl:block xl:absolute xl:-z-1 xl:left-[80%]"
          />
          <Image
            src="/about-team-2.svg"
            width={194}
            height={493}
            alt="Play video"
            className="hidden xl:block xl:absolute xl:-z-1 xl:left-[7%] xl:top-[35%]"
          />
        </ul>
      ) : null}
    </Wrap>
  );
};

export default Team;
